import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { InfoCircleFilled, InfoCircleOutlined } from "@ant-design/icons";
import { Space, Spin, Typography, theme } from "antd";
import { observer } from "mobx-react";
import { useEffect } from "react";
import { InvoiceRow } from "./invoiceRow.js";
import { InvoicesSkeleton } from "./invoicesSkeleton.js";
import { useStores } from "../../../../../store/stores.js";
import { __, _i } from "../../../../../utils/i18n.js";
import { EmptyState } from "../../emptyState.js";
import { InfoCard } from "../../infoCard.js";
import { BillingAddressInfoCard } from "../details/billingAddressInfoCard.js";
const InvoicesEmptyState = ()=>/*#__PURE__*/ _jsx(EmptyState, {
        heading: __("No invoices yet."),
        subline: __("Invoices appear here after your first purchase on devowl.io.")
    });
const EnvatoFooterCard = ()=>{
    const { token } = theme.useToken();
    return /*#__PURE__*/ _jsx(InfoCard, {
        variant: "primary-soft",
        icon: /*#__PURE__*/ _jsx(InfoCircleFilled, {
            style: {
                color: token.colorPrimary
            }
        }),
        children: _i(__("Bought on codecanyon.net? Your invoices for those purchases live there. {{link}}Open your codecanyon.net purchases{{/link}}"), {
            link: /*#__PURE__*/ _jsx(Typography.Link, {
                href: "https://codecanyon.net/downloads",
                target: "_blank",
                rel: "noreferrer"
            })
        })
    });
};
const InvoiceCard = observer(()=>{
    const { token } = theme.useToken();
    const { accountV2Store } = useStores();
    const { session } = accountV2Store;
    return /*#__PURE__*/ _jsxs("div", {
        className: "rc-account-v2-invoice-card",
        children: [
            /*#__PURE__*/ _jsx(Spin, {
                spinning: !!session?.isBusyInvoices,
                children: (session?.invoices ?? []).map((invoice)=>/*#__PURE__*/ _jsx(InvoiceRow, {
                        invoice: invoice
                    }, invoice.data.invoiceUrl ?? invoice.data.invoiceUrlPdf ?? `${invoice.data.createdAt}`))
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "rc-account-v2-invoice-card__notice",
                children: [
                    /*#__PURE__*/ _jsx(InfoCircleOutlined, {
                        style: {
                            color: token.colorTextTertiary,
                            marginTop: 1,
                            flexShrink: 0
                        }
                    }),
                    /*#__PURE__*/ _jsx("span", {
                        style: {
                            color: token.colorTextSecondary
                        },
                        children: __("Some invoices are issued by Paddle, who handles your payments on our behalf. All of them are official invoices for your bookkeeping.")
                    })
                ]
            })
        ]
    });
});
const InvoicesTab = observer(()=>{
    const { accountV2Store } = useStores();
    const { session } = accountV2Store;
    useEffect(()=>{
        session?.fetchInvoices();
    }, []);
    const invoiceCount = session?.invoices.length ?? 0;
    const isInitialLoad = !!session?.isBusyInvoices && invoiceCount === 0;
    const showEmpty = !session?.isBusyInvoices && invoiceCount === 0;
    return /*#__PURE__*/ _jsxs(Space, {
        direction: "vertical",
        size: 16,
        style: {
            width: "100%"
        },
        children: [
            isInitialLoad ? /*#__PURE__*/ _jsx(InvoicesSkeleton, {}) : showEmpty ? /*#__PURE__*/ _jsx(InvoicesEmptyState, {}) : /*#__PURE__*/ _jsx(InvoiceCard, {}),
            /*#__PURE__*/ _jsx(BillingAddressInfoCard, {
                showTabLink: false
            }),
            session?.hasEnvatoPurchase && /*#__PURE__*/ _jsx(EnvatoFooterCard, {})
        ]
    });
});
export { InvoicesTab };
